import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initAppInsights } from '@/lib/analytics'

initAppInsights()

// equip_services is always light mode — no dark mode toggle
document.documentElement.classList.add('light')
import { AuthProvider } from '@/context/AuthContext'
import { ImpersonationProvider } from '@/context/ImpersonationContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ImpersonationProvider>
          <App />
        </ImpersonationProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
